// 引入公共模块
import { 
  throttle,
  initActivityBannerHandler,
  mergeParams,
  addParamsToLinksHandler,
  pageJumpHandler,
  pageJumpBlankHandler,
  initScrollHandler,
  navSolutionsTabHandler
} from './common.js';

// 命名空间模式
const App = {
  init() {
    throttle();
    initActivityBannerHandler(); //专题横幅
    addParamsToLinksHandler(mergeParams()); //为链接添加参数
    pageJumpHandler(); //页面跳转
    pageJumpBlankHandler(); //页面跳转(新窗口打开)
    initScrollHandler();    
    navSolutionsTabHandler();
    this.headerScrollHandler();
    this.downPopupBtnHandler(); // 左下角安装包下载
    this.consultBtnHandler(); // 点击咨询弹窗
  },
  headerScrollHandler() {
    $(window).on('scroll', throttle(function() {
      const scrollPosition = $(window).scrollTop();

      // 导航栏样式变化
      const pageHeader = $(".uiam-header");
      if (scrollPosition > 110) {
        pageHeader.addClass("uiam-header-scroll-handler");
      } else {
        pageHeader.removeClass("uiam-header-scroll-handler");
      }
    }, 20));
    
  },
  downPopupBtnHandler() {
    // 左下角安装包下载
    $('.downloadPopupCloseBtn').on('click', () => {
      // 隐藏弹窗
      $('.download-popup-container').addClass('download-popup-hidden');
    })
  },
  consultBtnHandler () {
    // 点击咨询弹窗
    $('.consultBtn').on('click', ()=> {
      $('.uiam-consult-modal').addClass('uiam-consult-modal-active');
      // 禁用页面滚动
      $('body').addClass('scroll-lock');
    });

    // 关闭咨询弹窗
    $('.consultModalCloseBtn').on('click', ()=> {
      $('.uiam-consult-modal').removeClass('uiam-consult-modal-active');
      // 恢复页面滚动
      $('body').removeClass('scroll-lock');
    });

    
  }
};

// 文档加载后初始化
$(function () {
    App.init();
});
